var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Shpatel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A86oLVpmN72oM8L3LHKOba",
    x1: 21.162,
    x2: 25.268,
    y1: 5.458,
    y2: 21.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cdd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A86oLVpmN72oM8L3LHKOba)",
    d: "M39,25H9V8c0-1.105,0.895-2,2-2h26c1.105,0,2,0.895,2,2V25z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A86oLVpmN72oM8L3LHKObb",
    x1: 24,
    x2: 24,
    y1: 20.692,
    y2: 33.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1ea2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A86oLVpmN72oM8L3LHKObb)",
    d: "M9,25v2.319C9,29.904,11.096,32,13.681,32h5.983c0.516,0,0.902,0.472,0.799,0.977 C20.02,35.142,19,40.217,19,41c0,2.761,2.239,5,5,5s5-2.239,5-5c0-0.783-1.02-5.858-1.462-8.023C27.434,32.472,27.821,32,28.336,32 h5.983C36.904,32,39,29.904,39,27.319V25H9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Shpatel);
export default __webpack_public_path__ + "static/media/icons8-shpatel.a21ffbe71278295575fb7b047c1400f1.svg";
export { ForwardRef as ReactComponent };